import { DetailsLayout } from "components/DetailsLayout/DetailsLayout.component";
import { Loader } from "components/Loader/Loader.component";
import { useDefaultObservableBoolean } from "observables/BooleanObservable";
import { useTranslation } from "react-i18next";
import { userInfoPageService } from "service/shared/singletones/userInfoPageService/userInfoPage.service";
import { createComponent } from "utils/libExtend/createComponent";
import { useEffect } from "utils/libReplace/useEffect";

import { UserInfoContent } from "./UserInfoContent/UserInfoContent.component";
import { SUserInfoPageLoader } from "./UserInfoPageStyled/SUserInfoPageLoader.styled";

export const UserInfoPage = createComponent("UserInfoPage", () => {
  const { t } = useTranslation();
  useEffect(async () => {
    await userInfoPageService.controller.mount();
    return (): void => {
      userInfoPageService.controller.unMount();
    };
  }, []);

  const loaded = useDefaultObservableBoolean(userInfoPageService.state.loaded);

  return (
    <DetailsLayout title={t("userInfoPage.title")}>
      {loaded ? (
        <UserInfoContent />
      ) : (
        <SUserInfoPageLoader>
          <Loader />
        </SUserInfoPageLoader>
      )}
    </DetailsLayout>
  );
});
